import React from "react";
import Button from "../../../../../../_components/Button";
import { downaloadXML } from "../../../../../../api/nfe";
import { donwloadBase64 } from "../../../../../../utils";

export default (props) => {
  const [loading, setLoading] = React.useState(false);

  function downloadXML() {
    setLoading(true);
    downaloadXML(props.nfe.id)
      .then((resp) => {
        const { key, data } = resp;
        donwloadBase64(key, "xml", "application/xml", data);
        setLoading(false);
      })
      .catch(() => setLoading(false))
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 400);
      });
  }
  return (
    <Button
      as="text"
      className="text-danger ml-3"
      title="Baixar XML"
      onClick={downloadXML}
      disabled={loading}
    >
      {loading ? (
        <i class="fas fa-spinner fa-pulse" />
      ) : (
        <i className="fas fa-file-code text-info" />
      )}
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/List/Actions/DownloadXML/index.jsx